export default {
  nav: {
    main: 'Pääsivu',
    ordersAndInvoices: 'Tilaukset ja laskut',
    drafts: 'Luonnokset',
    automation: 'Automaatio',
    workspace: 'Työtila',
    templates: 'Mallipohjat',
    delivery: 'Toimitus',
    settings: 'Asetukset',
    shippingLabels: 'Toimitustarrat',
    subscriptions: 'Tilaukset',
    support: 'Tuki',
    developer: 'Kehittäjä',
    writeReview: 'Kirjoita arvostelu',
    supportTicket: 'Tukipyyntö',
    welcomeTour: 'Tervetulokierros',
    administratorConsole: 'Hallintakonsoli',
    logout: 'Kirjaudu ulos',
  },
  dashboard: {
    pageTitle: 'Tilaukset ja laskut',
    pageDescription: 'Manage your orders and invoices',
    title: 'Tilaukset ja laskut',
    selectedOrders: '{count} valittua tilausta',
    completed: '% valmis',
    processing: 'Käsitellään, odota...',
    bulkDownload: 'Joukkolataus',
    upgradeBulkDownload: 'Päivitä tilauksesi joukkolatausta varten',
    showFilters: 'Näytä suodattimet',
    hideFilters: 'Piilota suodattimet',
    creatingInvoices: 'Luodaan laskuja, odota...',
    bulkCreateInvoices: 'Luo laskut joukkona',
    cannotCreateAutopilot: 'Et voi luoda laskuja manuaalisesti, kun laskutustila on automaattinen.',
    exportInvoices: 'Vie laskut tai tilaukset',
    capturePayments: 'Ota maksut manuaalisesti',
    filterOrders: 'Suodata tilauksia',
    error: 'Hei, jokin meni pieleen...',
    close: 'Sulje',
    chooseDate: 'Valitse päivämäärä',
    chooseIssueDate: 'Valitse myöntämispäivä valituille laskuille',
    cancel: 'Peruuta',
    createInvoices: 'Luo laskut',
    storno: 'Storno',
    bulkOrderCapture: 'Tilausten joukkoveloitus',
  },
  search: {
    createdBetween: 'Luotu välillä',
    modifiedBetween: 'Muokattu välillä',
    orderNumber: 'Tilaus #',
    invoiceNumber: 'Lasku #',
    refundNumber: 'Hyvitys #',
    customer: 'Asiakas',
    payment: 'Maksu',
    any: 'Mikä tahansa',
    authorized: 'Valtuutettu',
    pending: 'Odottaa',
    paid: 'Maksettu',
    partiallyPaid: 'Osittain maksettu',
    refunded: 'Palautettu',
    voided: 'Mitätöity',
    partiallyRefunded: 'Osittain palautettu',
    unpaid: 'Maksamaton',
    fulfillment: 'Toimitus',
    fulfilled: 'Toimitettu',
    partial: 'Osittainen',
    unfulfilled: 'Toimittamaton',
    loading: 'Ladataan tilauksia...',
    search: 'Haku',
  },
  orderList: {
    noCustomer: 'Ei asiakasta',
    downloadOrder: 'Lataa tilaus',
    deleteWarning: 'Tärkeää! Tämä poistaa kaikki laskut ja hyvitykset, jotka on luotu päivämäärän jälkeen:',
    includingInvoice: 'mukaan lukien valittu lasku #',
    pressOk: 'Paina OK jatkaaksesi tai Peruuta keskeyttääksesi.',
    cannotCreateAutopilot: 'Et voi luoda laskuja manuaalisesti, kun laskutustila on automaattinen.',
    createInvoice: 'Luo lasku tälle tilaukselle',
    create: 'Luo',
    addCreditNote: 'Lisää hyvityslasku',
    createStorno: 'Luo stornolasku',
    refund: 'Hyvitys',
    downloadInvoice: 'Lataa tämä lasku',
    download: 'Lataa',
    default: 'Oletus',
    downloadStorno: 'Lataa tämä storno-/hyvityslasku',
    fulfillOrder: 'Toimita tilaus',
    orderNum: 'Tilaus #',
    locPrefix: 'Sijaintietuliite',
    invoiceNum: 'Lasku #',
    refundNum: 'Hyvitys #',
    customerCol: 'Asiakas',
    orderCreatedDate: 'Tilauksen luontipäivä',
    orderModifiedDate: 'Tilauksen muokkauspäivä',
    delivered: 'Toimitettu',
    paymentStatus: 'Maksun tila',
    fulfillmentStatus: 'Toimitustila',
    totalOutstanding: 'Avoin kokonaissumma',
    originalPrice: 'Alkuperäinen hinta',
    noOrders: 'Kaupallasi ei ole tilauksia valitulle tilalle.',
    cannotCreateNoOrders: 'Et voi luoda laskuja, kun tilauksia ei ole.',
    createOrdersFirst: 'Luo vähintään yksi tilaus ja yritä uudelleen.',
    createOrders: 'Luo tilauksia',
    loadingOrders: 'Ladataan...',
    paidManual: 'Maksettu - Manuaalinen',
    paid: 'Maksettu',
    refunded: 'Palautettu',
    pending: 'Odottaa',
    partiallyPaid: 'Osittain maksettu',
    partiallyRefunded: 'Osittain palautettu',
    fulfilled: 'Toimitettu',
    unfulfilled: 'Toimittamaton',
    deliveryPending: 'Odottaa',
    deliverNow: 'Toimita nyt',
    deliveryPartial: 'Osittainen',
    notDelivered: 'Ei toimitettu',
    deliverAgain: 'Toimita uudelleen',
    deliveryDetails: 'Toimituksen tiedot',
    deliveryFailed: 'Toimitus epäonnistui',
    sent: 'Lähetetty',
    failed: 'Epäonnistui',
    toLabel: 'Vastaanottaja',
    folderLabel: 'Kansio',
    open: 'Avaa',
    invoice: 'Lasku',
    creditNote: 'Hyvityslasku',
    stornoLabel: 'Storno',
    unknown: 'Tuntematon',
    googleDrive: 'Google Drive',
    clientsTablet: 'Asiakastabletti',
    shippyPro: 'ShippyPro',
    emailChannel: 'Sähköposti',
    ftpChannel: 'FTP',
    revertToDate: 'Palauta tähän päivämäärään',
    add: 'Lisää',
    close: 'Sulje',
  },
  downloadDialog: {
    downloadType: 'Lataa {type}...',
    selectTemplate: 'Valitse mallipohja galleriasta viedäksesi tilauksia, laskuja, stornolaskuja tai hyvityslaskuja.',
    getMoreTemplates: 'Hae lisää mallipohjia',
    createNewTemplate: 'Luo uusi mallipohja',
    allCreatedBetween: 'Kaikki luodut {type} välillä',
    selectedType: 'Valitut {type}',
    and: 'ja',
    status: 'Tila',
    any: 'Mikä tahansa',
    open: 'Avoin',
    closed: 'Suljettu',
    cancelled: 'Peruutettu',
    paymentStatus: 'Maksun tila',
    fulfillmentStatus: 'Toimitustila',
    fulfilled: 'Toimitettu',
    partial: 'Osittainen',
    unfulfilled: 'Toimittamaton',
    authorized: 'Valtuutettu',
    pending: 'Odottaa',
    paid: 'Maksettu',
    partiallyPaid: 'Osittain maksettu',
    refunded: 'Palautettu',
    voided: 'Mitätöity',
    partiallyRefunded: 'Osittain palautettu',
    unpaid: 'Maksamaton',
    format: 'Muoto',
    forLocation: 'Sijainti',
    advancedOptions: 'Lisäasetukset',
    exportHSCodes: 'Vie varaston HS-koodit (hitaampi)',
    noteChrome: 'Huomaa: Optimaalisen latauksen vuoksi suositellaan Chromea ja mainosten estäjän poistamista käytöstä.',
    downloadIndividually: 'Lataa yksitellen',
    downloadGrouped: 'Lataa ryhmitettynä',
  },
  templates: {
    pageTitle: 'Mallipohjat',
    pageDescription: 'Customize your invoice templates',
    title: 'Mallipohjat',
    installTranslated: 'Asenna käännetty mallipohja',
    installTranslatedDesc: 'Valitse eri kieli napsauttamalla tätä painiketta.',
    createNew: 'Luo uusi mallipohja tarvittaessa',
    createNewDesc: 'Napsauta tätä painiketta luodaksesi uuden mallipohjan tarvittaessa.',
    customize: 'Mukauta mallipohjia',
    customizeDesc: 'Napsauta oletusmallipohja muokataksesi sitä. Voit vaihtaa logon, värit ja edistyneemmille käyttäjille taustalla olevan koodin.',
    defaultTemplate: 'Lasku, storno ja hyvityslasku (Oletus)',
    logo: 'Logo',
    colorPalette: 'Väripaletti',
    getColorPalettes: 'Hae väripaletteja',
    paperSize: 'Paperikoko',
    format: 'Muoto',
    a3: 'A3 (297 x 420 mm)',
    a4: 'A4 (210 x 297 mm)',
    a5: 'A5 (148 x 210 mm)',
    legal: 'Legal (215.9 x 355.6 mm)',
    letter: 'Letter (215.9 x 279.4 mm)',
    tabloid: 'Tabloid (279.4 x 431.8 mm)',
    mcPrint3: 'mC-Print3 Roll (80 x 155 mm)',
    mcPrint2: 'mC-Print2 Roll (57.5 x 155 mm)',
    orientation: 'Suunta',
    landscape: 'Vaaka',
    portrait: 'Pysty',
    margin: 'Marginaali (cm)',
    unsavedChanges: 'Tallentamattomat muutokset',
    discard: 'Hylkää',
    save: 'Tallenna',
  },
  labels: {
    pageTitle: 'Toimitustarrat',
    pageDescription: 'Create and manage shipping labels',
    title: 'Toimitustarrat',
    glsRequiresPro: 'GLS-toimitustarrat EEU-alueelle vaatii Professional-tilauksen.',
    upgradeDesc: 'Päivitä Professional-tilaukseen luodaksesi ja hallitaksesi toimitustarroja.',
    upgradePlan: 'Päivitä tilauksesi',
    eeuGls: 'EEU GLS',
    enabled: 'Käytössä',
    country: 'Maa',
    hungary: 'Unkari',
    slovakia: 'Slovakia',
    czech: 'Tšekki',
    romania: 'Romania',
    slovenia: 'Slovenia',
    croatia: 'Kroatia',
    senderId: 'Lähettäjän tunnus',
    username: 'Käyttäjätunnus',
    password: 'Salasana',
    name: 'Nimi',
    city: 'Kaupunki',
    address: 'Osoite',
    zipCode: 'Postinumero',
    contactPerson: 'Yhteyshenkilö',
    phone: 'Puhelin',
    email: 'Sähköposti',
    glsServices: 'GLS-palvelut',
    expressService: 'Pikapalvelu',
    exchangeService: 'Vaihtopalvelu',
    smsService: 'SMS-palvelu',
    smsText: 'SMS-teksti',
    preAdviceService: 'Ennakkoilmoituspalvelu',
    unsavedChanges: 'Tallentamattomat muutokset',
    discard: 'Hylkää',
    save: 'Tallenna',
  },
  billing: {
    pageTitle: 'Laskutus',
    pageDescription: 'Manage your subscription and billing',
    title: 'Laskutus',
    subscriptionFor: 'Tilaus kaupalle',
    currentlySubscribed: 'Olet tällä hetkellä tilannut',
    plan: 'tilauksen',
    cancelSubscription: 'Peruuta tilaus',
    upgradePlan: 'Päivitä tilauksesi',
    professional: 'Professional',
    proPriceMonthly: '$29.99 / kuukausi',
    upgrade: 'Päivitä',
    includesAllStarter: 'Sisältää kaikki Starter-ominaisuudet sekä:',
    proFeature1: 'Globaali vaatimustenmukaisuus: Sijaintipohjaiset etuliitteet ja mukautettu juokseva numerointi',
    proFeature2: 'Älykäs lokalisointi: Automaattisesti käännetyt sähköpostit ja lokalisoidut PDF-liitteet',
    proFeature3: 'Täydellinen B2B-dokumenttien elinkaari: Proformat, B2B-tarjoukset ja hyvityslaskut',
    proFeature4: 'B2B-kirjanpidon synkronointi: 3 desimaalin tarkkuus ja monivaluuttanäytöt',
    proFeature5: 'Automaattiset varmuuskopiot: Kopioi laskut automaattisesti turvalliselle FTP:lle tai Google Drive -palveluun',
    proFeature6: 'Shopify Flow: Automatisoi laskujen luonti, toimitus ja storno Flow-triggereiden ja toimintojen avulla',
    proFeature7: 'Edistynyt tekoälylogiikka: Käytä laitteen tekoälyä monimutkaisiin ehdollisiin asettelulausekkeisiin',
    proFeature8: 'UBL XML & ZUGFeRD / Factur-X -vienti (Eurooppalainen sähköisen laskutuksen vaatimustenmukaisuus)',
    proFeature9: 'EPC QR -koodit välittömiin mobiili-POS-maksuihin',
    proFeature10: 'GLS-toimitustarrat EEU-alueelle',
    proFeature11: '7 vuoden verotuksellinen säilytysaika',
    currentlyUsing: 'Käytät tällä hetkellä',
    free: 'ilmaista',
    subscriptionPlan: 'tilaussuunnitelmaa.',
    monthlyUsage: 'Kuukausittainen käyttö',
    monthlyGenerated: '{count} / 50 laskua tässä kuussa',
    monthlyLimitReached: 'Kuukausittainen raja saavutettu. Päivitä Starter-tilaukseen rajattomia laskuja varten.',
    freePlan: 'Ilmainen tilaus',
    freeToInstall: 'Ilmainen asennus',
    freeFeature1: 'Enintään 50 laskua/tilausta kuukaudessa',
    freeFeature2: 'Pääsy kaikkiin 31+ valmiisiin mallipohjiin',
    freeFeature3: 'Perus-tekoälyavustaja',
    freeFeature4: 'Vakio-PDF-lataukset ja tulostus',
    freeFeature5: 'Vakioasiakirjat (Laskut, lähetyslistat, kuitit)',
    freeFeature6: '3 kuukauden turvallinen laskujen säilytys',
    starterPlan: 'Starter-tilaus',
    starterPrice: '$9.99 / kuukausi',
    starterPricePerInvoice: '+ 3¢ per luotu lasku',
    subscribe: 'Tilaa',
    starterFeature1: 'Rajattomat laskut ja tilaukset',
    starterFeature2: 'Automaattinen PDF-toimitus sähköpostitse',
    starterFeature3: 'Täysi pääsy hybridieditoriin ja tekoälyavustajaan',
    starterFeature4: 'Shopify POS ja viivakoodiintegraatio',
    starterFeature5: 'Shopify Flow: Triggerit ja toiminnot laskuautomaatioon',
    starterFeature6: 'UBL XML / PEPPOL & ZUGFeRD / Factur-X -vienti (Sähköisen laskutuksen vaatimustenmukaisuus)',
    starterFeature7: '1 vuoden turvallinen laskujen säilytys',
    proTaxOverrides: 'Mukautetut veromuutokset: ALV / GST tuotekohtaisesti ja SKU-tason verokannat',
    unsavedChanges: 'Tallentamattomat muutokset',
    discard: 'Hylkää',
    save: 'Tallenna',
  },
  autopilot: {
    pageTitle: 'Automaatio',
    pageDescription: 'Automate invoice creation and management',
    title: 'Automaatio',
    autoCreate: 'Luo laskut automaattisesti',
    disabled: 'Pois käytöstä (Manuaalinen)',
    whenCreated: 'Kun tilaukset luodaan',
    whenFulfilled: 'Kun tilaukset toimitetaan',
    whenPaid: 'Kun tilaukset maksetaan',
    autoCreateDesc: 'Laskut luodaan päivämääränä, jolloin tilaukset luodaan, toimitetaan tai maksetaan.',
    autoStorno: 'Stornoi laskut automaattisesti',
    whenCancelled: 'Kun tilaukset peruutetaan tai hyvitetään',
    autoStornoDesc: 'Stornolaskut luodaan päivämääränä, jolloin tilaukset mitätöidään/peruutetaan tai hyvitykset luodaan.',
    cannotAutoFree: 'Laskujen automaattista luontia ei voi käyttää ilmaisella tilauksella.',
    upgradePlan: 'Päivitä tilauksesi',
    unsavedChanges: 'Tallentamattomat muutokset',
    discard: 'Hylkää',
    save: 'Tallenna',
  },
  delivery: {
    pageTitle: 'Toimitus',
    pageDescription: 'Configure invoice delivery via email, FTP, or Google Drive',
    title: 'Toimitus',
    settings: 'Asetukset',
    useOrderNumbers: 'Käytä tilausnumeroita tiedostonimissä',
    sendIfCountry: 'Lähetä, jos laskutusosoitteen maa on',
    countryCodesHint: 'Listaa kaikki maakoodit puolipisteellä erotettuna.',
    sendForTags: 'Lähetä asiakkaille, joilla on jokin luetelluista tunnisteista',
    tagsHint: 'Listaa kaikki tunnisteet puolipisteellä erotettuna.',
    emailDelivery: 'Sähköpostitoimitus',
    sendAsPdf: 'Lähetä laskut PDF-liitteinä asiakkaille',
    autoSend: 'Lähetä automaattisesti, kun lasku luodaan',
    subject: 'Aihe',
    body: 'Viesti',
    xmlAttachments: 'XML-liitteet',
    attachUbl: 'Liitä UBL/PEPPOL XML (E-Factura)',
    attachZugferd: 'Liitä ZUGFeRD / Factur-X XML',
    sendTestEmail: 'Lähetä testisähköposti',
    sending: 'Lähetetään...',
    customSmtp: 'Mukautettu SMTP-palvelin',
    customSmtpDesc: 'Käytä omaa sähköpostipalvelinta oletuksen sijaan',
    enableSmtp: 'Ota mukautettu SMTP käyttöön',
    smtpHost: 'SMTP-palvelin',
    port: 'Portti',
    useSsl: 'Käytä SSL/TLS',
    username: 'Käyttäjätunnus',
    password: 'Salasana',
    fromEmail: 'Lähettäjän sähköposti',
    fromName: 'Lähettäjän nimi',
    shopifyLiquid: 'Shopify Liquid -mallipohja',
    pasteInto: 'Liitä tämä',
    orderConfirmation: 'tilausvahvistusmallipohjaan',
    toAddLink: 'lisätäksesi latauslinkin.',
    downloadInvoice: 'Lataa laskusi',
    clientsTablet: 'ClientsTablet',
    clientsTabletDesc: 'Lähetä pyynnöt ClientsTablet-palveluun, kun laskut luodaan',
    shippyPro: 'ShippyPro',
    shippyProDesc: 'Lähetä PDF-laskut tulliasiakirjoina ShippyPro-palveluun EU:n ulkopuolisille maille',
    ftpBackup: 'FTP/SFTP-varmuuskopiointi',
    ftpDesc: 'Kopioi laskut automaattisesti palvelimellesi',
    enableFtp: 'Ota automaattinen FTP-varmuuskopiointi käyttöön',
    host: 'Palvelin',
    useSftp: 'Käytä SFTP:tä (suojattu)',
    destinationFolder: 'Kohdekansio',
    xmlFiles: 'XML-tiedostot',
    includeUbl: 'Sisällytä UBL/PEPPOL XML (E-Factura)',
    includeZugferd: 'Sisällytä ZUGFeRD / Factur-X XML',
    testConnection: 'Testaa yhteys',
    testing: 'Testataan...',
    pro: 'PRO',
    upgradeFtp: 'Päivitä Professional-tilaukseen kopioidaksesi laskut automaattisesti FTP/SFTP-palvelimellesi.',
    googleDrive: 'Google Drive',
    googleDriveDesc: 'Synkronoi laskut automaattisesti Drive-palveluun',
    connected: 'Yhdistetty',
    disconnect: 'Katkaise yhteys',
    notWorking: 'Eikö toimi? Siirry',
    googlePermissions: 'Google-käyttöoikeudet',
    removeThenReconnect: 'poista Invoice Browse ja yhdistä uudelleen.',
    connectGoogleDrive: 'Yhdistä Google Drive',
    upgradeGoogleDrive: 'Päivitä Professional-tilaukseen synkronoidaksesi laskut automaattisesti Google Drive -palveluun.',
    unsavedChanges: 'Tallentamattomat muutokset',
    discard: 'Hylkää',
    freePlanTitle: 'Automated delivery is not available on the free plan',
    freePlanDesc: 'Upgrade to Starter or Professional to automatically send invoices via email, FTP, or Google Drive.',
    emailLiquidTemplate: 'Email Liquid Template',
    liquidTemplateDesc: 'Copy and paste this code to your order confirmation template. Click {link} to open it.',
    here: 'here',
    save: 'Tallenna',
  },
  bookkeeping: {
    pageTitle: 'Asetukset',
    pageDescription: 'Configure your invoice settings',
    title: 'Asetukset',
    owner: 'Omistaja',
    email: 'Sähköposti',
    phone: 'Puhelin',
    keepDifferentNumbering: 'Pidä eri laskujen numerointi jokaiselle tilauksen sijainnille',
    keepDifferentNumberingDisabled: 'Eri laskujen numerointi jokaiselle tilauksen sijainnille ei ole käytettävissä nykyisellä tilauksellasi.',
    locationEmailDesc: 'Tämä mahdollistaa sähköpostien ja laskujen lähettämisen käännettynä tilauksen sijainnin perusteella: varastosijainti, toimitusosoite tai laskutusosoite',
    upgradePlan: 'Päivitä tilauksesi',
    matchingCriteria: 'Vastaavuusehdot',
    locationId: 'Sijainnin tunnus',
    shippingCountryCode: 'Toimitusosoitteen maakoodi',
    billingCountryCode: 'Laskutusosoitteen maakoodi',
    matchLocationDesc: 'Yhdistä sijainti tilauksen sijainnin tunnuksen, toimitusosoitteen tai laskutusosoitteen maakoodin perusteella.',
    companyInfo: 'Yritystiedot',
    name: 'Nimi',
    website: 'Verkkosivusto',
    registrationNumber: 'Y-tunnus',
    taxId: 'ALV-tunnus',
    addressSection: 'Osoite',
    streetName: 'Kadun nimi',
    streetNumber: 'Kadun numero',
    zip: 'Postinumero',
    city: 'Kaupunki',
    region: 'Alue',
    country: 'Maa',
    bankingInfo: 'Pankkitiedot',
    bankName: 'Pankin nimi',
    swift: 'Swift',
    currency: 'Valuutta',
    iban: 'IBAN',
    invoicing: 'Laskutus',
    decimalPlaces: 'Desimaalien määrä',
    invoicesPrefix: 'Laskujen etuliite',
    currentInvoiceNumber: 'Nykyinen laskunumero',
    creditNotesPrefix: 'Hyvityslaskujen etuliite',
    currentCreditNoteNumber: 'Nykyinen hyvityslaskun numero',
    lastInvoiceDate: 'Viimeinen laskun päivämäärä',
    noInvoicesYet: 'Laskuja ei ole vielä luotu.',
    confirmReverting: 'Vahvista järjestelmän palautus',
    allInvoicesAfter: 'Kaikki laskut ja niiden stornot, jotka on luotu',
    willBeRemoved: 'jälkeen poistetaan. Jatketaanko järjestelmän palautusta?',
    cancel: 'Peruuta',
    revert: 'Palauta',
    revertDesc: 'Järjestelmän palautus poistaa kaikki valitun päivämäärän jälkeen luodut laskut.',
    revertToDate: 'Palauta tähän päivämäärään',
    reverting: 'Palautetaan järjestelmää, odota...',
    useOrderNumbering: 'Käytä tilausnumerointia',
    showVat: 'Näytä ALV laskuissa',
    overrideTaxes: 'Ohita verot',
    pricesIncludeTax: 'Hinnat sisältävät veron',
    productsTaxRate: 'Tuotteiden verokanta',
    shippingTaxRate: 'Toimituksen verokanta',
    skusSeparated: 'SKU:t puolipisteellä erotettuna',
    skusTaxRate: 'SKU-verokanta',
    useOrderDates: 'Käytä tilauksen luontipäivämääriä laskuissa',
    convertCurrency: 'Muunna hinnat valuuttaan, jolla asiakas maksaa',
    unsavedChanges: 'Tallentamattomat muutokset',
    discard: 'Hylkää',
    save: 'Tallenna',
  },
  drafts: {
    pageTitle: 'Luonnokset',
    pageDescription: 'Manage your draft orders',
    title: 'Luonnokset',
    download: 'Lataa',
    newDraft: 'Uusi luonnos',
    exporting: 'Viedään {status}%...',
    accessNotGranted: 'Luonnostilauksien käyttöoikeutta ei myönnetty. Ole hyvä ja',
    reLogin: 'kirjaudu uudelleen',
    toGrantPermissions: 'myöntääksesi vaaditut "Luonnokset"-käyttöoikeudet.',
    pushFailed: 'Lähetys Shopify-palveluun epäonnistui:',
    exportError: 'Vientivirhe:',
    confirmDelete: 'Haluatko varmasti poistaa tämän luonnoksen?',
    incompleteCustomer: 'Asiakastiedot ovat puutteelliset:',
    pushWithoutCustomer: 'Luonnos lähetetään Shopify-palveluun ilman asiakastietoja. Jatketaanko?',
    customerNotInShopify: 'Tätä asiakasta ei ole vielä Shopify-palvelussa.',
    warnings: 'Varoitukset:',
    createCustomerAndPush: 'Luodaanko asiakas Shopify-palveluun ja lähetetäänkö luonnostilaus?',
    downloadTitle: 'Lataa luonnokset',
    cancel: 'Peruuta',
  },
  draftEdit: {
    number: "Numero",
    prefix: "Etuliite",

    newDraft: 'Uusi luonnos',
    editDraft: 'Muokkaa luonnosta',
    viewInShopify: 'Näytä Shopify-palvelussa',
    back: 'Takaisin',
    createDraft: 'Luo luonnos',
    saveChanges: 'Tallenna muutokset',
    documentType: 'Asiakirjatyyppi',
    draftOrder: 'Luonnostilaus',
    quote: 'Tarjous',
    proforma: 'Proforma',
    manualInvoice: 'Manuaalinen lasku',
    currency: 'Valuutta',
    expiryDate: 'Viimeinen voimassaolopäivä',
    status: 'Tila',
    draft: 'Luonnos',
    sent: 'Lähetetty',
    accepted: 'Hyväksytty',
    customer: 'Asiakas',
    firstName: 'Etunimi',
    lastName: 'Sukunimi',
    email: 'Sähköposti',
    phone: 'Puhelin',
    company: 'Yritys',
    taxId: 'ALV-tunnus',
    billingAddress: 'Laskutusosoite',
    address: 'Osoite',
    aptSuite: 'Huoneisto',
    city: 'Kaupunki',
    province: 'Maakunta',
    countryField: 'Maa',
    zip: 'Postinumero',
    shippingAddress: 'Toimitusosoite',
    sameAsBilling: 'Sama kuin laskutusosoite',
    lineItems: 'Rivinimikkeet',
    shipping: 'Toimitus',
    shippingTitle: 'Otsikko',
    shippingPlaceholder: 'esim. Vakiotoimitus',
    price: 'Hinta',
    note: 'Huomautus',
    notePlaceholder: 'Sisäinen muistiinpano tai viesti asiakkaalle...',
    summary: 'Yhteenveto',
    subtotal: 'Välisumma',
    discounts: 'Alennukset',
    tax: 'Vero',
    total: 'Yhteensä',
  },
  login: {
    pageTitle: 'Invoice Browse - Monthly batch invoicing',
    enterShopAddress: 'Syötä kauppasi osoite',
    loginWith: 'Kirjaudu sisään',
    createAccount: 'Luo uusi tili',
    placeholder: 'kauppasi-nimi',
    shopRequired: 'Kaupan nimi vaaditaan',
    login: 'Kirjaudu',
    shopify: 'Shopify',
    terms: 'Käyttöehdot',
    privacy: 'Tietosuojakäytäntö',
  },
  developer: {
    pageTitle: 'Developer Tools',
    pageDescription: 'Developer tools and API configuration',
  },
  leads: {
    pageTitle: 'Leads',
    pageDescription: 'Manage your leads',
  },
  review: {
    enjoying: 'Pidätkö Invoice Browse -sovelluksesta?',
    description: 'Olet luonut ensimmäiset laskusi! Jos sovellus on mielestäsi hyödyllinen, nopea arvostelu Shopify App Storessa auttaa meitä paljon.',
    reward: 'Kiitokseksi nollaamme kuukausittaisen käyttölaskurisi',
    leaveReview: 'Jätä arvostelu',
    maybeLater: 'Ehkä myöhemmin',
  },
  footer: {
    copyright: '© 2026 Growth Connections',
  },
  joyride: {
    welcomeTitle: 'Tervetuloa Invoice Browse -sovellukseen',
    welcomeContent: 'Näytän sinulle, miten voit käyttää sitä.',
    dashboardTitle: 'Hallintapaneeli',
    dashboardContent: 'Näkemäsi näyttö on päähallintapaneeli. Täältä löydät kaikki tilaukset ja voit viedä ne eri asiakirjatyypeiksi, kuten: laskut, lähetyslistat ja muut.',
    automationTitle: 'Tee elämästäsi helpompaa',
    automationContent: 'Ota automaatio käyttöön luodaksesi laskut aina kun tilaukset maksetaan tai hyvitetään.',
    templatesTitle: 'Mukauta mallipohjia',
    templatesContent: 'Siirry tänne kääntääksesi mallipohjan, muokataksesi sitä tai luodaksesi uuden.',
    deliveryTitle: 'Toimitus',
    deliveryContent: 'Määritä sovelluksemme kopioimaan luodut asiakirjat automaattisesti FTP:lle, Google Drive -palveluun tai sähköpostin liitteiksi.',
    settingsTitle: 'Asetukset',
    settingsContent1: 'Muokkaa yrityksen puhelinnumeroa, sähköpostia ja muita asiakirjoissa käytettäviä kenttiä.',
    settingsContent2: 'Vaihda asiakirjan aloitusnumero tai poista tietyn päivämäärän jälkeen luodut asiakirjat.',
    settingsContent3: 'Ohita ALV-prosentit toimitukselle ja tuotteille',
    settingsContent4: 'Vaihda desimaalien määrä numeroissa',
    reviewTitle: 'Kirjoita arvostelu',
    reviewContent: 'Tue tiimiämme kirjoittamalla meille hyvä arvostelu!',
    tourTitle: 'Tervetulokierros',
    tourContent: 'Hei, voit avata tämän kierroksen uudelleen täältä.',
    createDocTitle: 'Luo ensimmäinen asiakirjasi',
    createDocContent: 'Napsauta Luo-painiketta luodaksesi ensimmäisen asiakirjasi.',
    docNumberTitle: 'Asiakirjan numero',
    docNumberContent: 'Ensimmäiselle asiakirjalle on varattu numero 1. Jos haluat aloittaa toisella numerolla, voit muuttaa sen Asetuksista.',
    downloadDocTitle: 'Lataa asiakirja',
    downloadDocContent: 'Napsauta Lataa-pudotusvalikkoa ja valitse asiakirjamallipohja viedäksesi tilauksesi PDF-muodossa.',
  },
  common: {
    save: 'Tallenna',
    cancel: 'Peruuta',
    close: 'Sulje',
    discard: 'Hylkää',
    delete: 'Poista',
    edit: 'Muokkaa',
    create: 'Luo',
    loading: 'Ladataan...',
    unsavedChanges: 'Tallentamattomat muutokset',
    upgradePlan: 'Päivitä tilauksesi',
  },
  languageSelector: {
    label: 'Kieli',
    auto: 'Tunnista automaattisesti',
  },
  draftList: {
    draftNum: 'Luonnos #',
    shopifyId: 'Shopify ID',
    type: 'Tyyppi',
    customer: 'Asiakas',
    total: 'Yhteensä',
    status: 'Tila',
    delivered: 'Toimitettu',
    date: 'Päivämäärä',
    actions: 'Toiminnot',
    noCustomer: 'Ei asiakasta',
    noDrafts: 'Luonnoksia tai tarjouksia ei löytynyt.',
    loading: 'Ladataan...',
    download: 'Lataa',
    default: 'Oletus',
    pending: 'Odottaa',
    deliverNow: 'Toimita nyt',
    deliveryDetails: 'Toimitustiedot',
    sent: 'Lähetetty',
    failed: 'Epäonnistui',
    deliverAgain: 'Toimita uudelleen',
    partial: 'Osittainen',
    notDelivered: 'Ei toimitettu',
    deliveryFailed: 'Toimitus epäonnistui',
    unknown: 'Tuntematon',
    edit: 'Muokkaa',
    send: 'Lähetä',
    pushToShopify: 'Lähetä Shopifyyn',
    complete: 'Valmis',
    duplicate: 'Kopioi',
    delete: 'Poista',
    quote: 'Tarjous',
    proforma: 'Proforma',
    draftOrder: 'Luonnostilaus',
    manualInvoice: 'Manuaalinen lasku',
  },
  draftSearch: {
    createdBtw: 'Luotu välillä',
    draftNum: 'Draft #',
    shopifyId: 'Shopify ID',
    customer: 'Asiakas',
    status: 'Tila',
    type: 'Tyyppi',
    delivery: 'Toimitus',
    any: 'Kaikki',
    draft: 'Luonnos',
    sent: 'Lähetetty',
    accepted: 'Hyväksytty',
    expired: 'Vanhentunut',
    converted: 'Muunnettu',
    cancelled: 'Peruttu',
    quote: 'Tarjous',
    proforma: 'Proforma',
    draftOrder: 'Luonnostilaus',
    manualInvoice: 'Manuaalinen lasku',
    delivered: 'Toimitettu',
    notDelivered: 'Ei toimitettu',
    pending: 'Odottaa',
    search: 'Hae',
  },
  draftDownload: {
    title: 'Lataa Luonnos #...',
    selectTemplate: 'Select a template from the gallery to export drafts, quotes, or proformas.',
    allDraftsBetween: 'All drafts between',
    selectedDrafts: 'Selected drafts',
    and: 'and',
    status: 'Tila',
    documentType: 'Tyyppi',
    any: 'Kaikki',
    draft: 'Luonnos',
    sent: 'Lähetetty',
    accepted: 'Hyväksytty',
    expired: 'Vanhentunut',
    converted: 'Muunnettu',
    cancelled: 'Peruttu',
    quote: 'Tarjous',
    proforma: 'Proforma',
    draftOrder: 'Luonnostilaus',
    manualInvoice: 'Manuaalinen lasku',
    format: 'Format',
    noTemplates: 'No templates found',
    noTemplatesForType: 'No templates found for document type "{type}".',
    installTemplates: 'Install templates',
    toStartExporting: 'to start exporting.',
    noteChrome: 'Note: For optimal download Chrome browser is recommended and any Adblocker to be disabled.',
    cancel: 'Cancel',
    downloadIndividually: 'Download Individually',
    downloadGrouped: 'Download Grouped',
  },
  templateEditor: {
    pageTitle: 'Template Editor',
    pageDescription: 'Edit and customize your invoice template',
    installNewTemplate: 'Asenna uusi malli',
    tabStyle: 'Tyyli',
    tabContent: 'Sisältö',
    tabTranslations: 'Käännökset',
    tabSettings: 'Asetukset',
    tabCode: 'Koodi',
    tabCopilot: 'AI-kopilotti',
    logo: 'Logo',
    colorPalette: 'Väripaletti',
    colorText: 'Text',
    colorBg: 'BG',
    colorBorder: 'Border',
    colorPrimary: 'Primary',
    colorAccent: 'Accent',
    font: 'Font',
    fontDefault: 'Default (DM Sans)',
    fontSize: 'Font Size',
    fontSizeDefault: 'Default (11.5px)',
    fontSizeCompact: 'Compact',
    fontSizeSmall: 'Small',
    fontSizeMediumSmall: 'Medium Small',
    fontSizeMedium: 'Medium',
    fontSizeMediumLarge: 'Medium Large',
    fontSizeLarge: 'Large',
    fontSizeExtraLarge: 'Extra Large',
    documentTitle: 'Document Title',
    documentTitlePlaceholder: 'e.g. Invoice, Tax Invoice, Factura...',
    noToggleSupport: 'This template does not support toggle controls. Switch to a gallery template for full customization.',
    sections: 'Sections',
    shippingAddress: 'Shipping address',
    bankPaymentDetails: 'Bank / payment details',
    paymentStatusBadge: 'Payment status badge',
    orderNotes: 'Order notes',
    trackingFulfillment: 'Tracking / fulfillment info',
    termsConditions: 'Terms & conditions',
    signatureLines: 'Signature lines',
    qrCode: 'QR code',
    lineItems: 'Line Items',
    taxColumns: 'Tax columns (VAT / GST)',
    productSku: 'Product SKU',
    productImages: 'Product images',
    discountBreakdown: 'Discount breakdown',
    itemWeight: 'Item weight',
    hsCode: 'HS code (customs)',
    mergeDiscounts: 'Merge discounts into product price',
    showOrderDiscountAsSummary: 'Show order discount as a summary line',
    totals: 'Totals',
    subtotalBeforeTax: 'Subtotal (before tax)',
    taxBreakdownByRate: 'Tax breakdown by rate',
    shippingCostSeparate: 'Shipping cost as separate line',
    dueDate: 'Due date',
    formatting: 'Formatting',
    dateFormat: 'Date format',
    decimalPlaces: 'Decimal places',
    paymentTerms: 'Payment terms',
    paymentTermsNone: 'None',
    thankYouMessage: 'Thank you message',
    thankYouPlaceholder: 'Thank you for your business!',
    countryMatchTitle: 'Use this template when shipping or billing address matches this country',
    addressType: 'Address Type',
    addressDisabled: 'Disabled',
    addressShipping: 'Shipping Address',
    addressBilling: 'Billing Address',
    country: 'Country',
    anyCountry: 'Any country',
    countryMatchDesc: 'When enabled, this template will be used automatically for orders where the selected address matches the chosen country.',
    languagePreset: 'Language Preset',
    selectLanguage: 'Select a language...',
    languagePresetDesc: 'Selecting a language fills in all labels below. You can then customize individual fields.',
    paperSize: 'Paper Size',
    format: 'Format',
    orientation: 'Orientation',
    portrait: 'Portrait',
    landscape: 'Landscape',
    margin: 'Margin (cm)',
    template: 'Template',
    templateName: 'Name',
    systemAlias: 'System Alias',
    systemAliasDesc: 'for POS/Admin URL routes',
    systemAliasNone: 'None',
    defaultTemplate: 'Default template',
    defaultTemplateDesc: 'Used for direct links shared with customers.',
    posRouteDesc: 'Maps to /template/[alias]/receipt.pdf for POS integration.',
    documentType: 'Document Type',
    invoiceCreditNote: 'Invoice + Credit Note',
    order: 'Order',
    invoiceOnly: 'Invoice only',
    quoteEstimate: 'Quote / Estimate',
    proformaInvoice: 'Proforma Invoice',
    refund: 'Refund',
    stornoInvoice: 'Storno Invoice',
    creditNoteOnly: 'Credit Note only',
    reportLiquid: 'Report (Liquid only)',
    hideRemovedItems: 'Hide removed/refunded line items',
    location: 'Location',
    locationEmpty: 'Leave empty to use for all locations',
    dangerZone: 'Danger Zone',
    dangerZoneDesc: 'Permanently remove this template from your account.',
    removeTemplate: 'Remove template',
    bodyTemplate: 'Body Template',
    bodyTemplateDesc: 'Uses Mustache or Liquid syntax. Click a snippet:',
    rowTemplate: 'Row Template',
    rowTemplateDesc: 'Rendered once per line item. Click a snippet:',
    variableReference: 'Variable Reference',
    formatCode: 'Format Code',
    insert: 'Insert',
    copy: 'Copy',
    loadModelContinue: 'Load Model & Continue',
    cancel: 'Cancel',
    copilotPlaceholder: 'Try: translate to Romanian, show tax columns, add barcode, use teal palette...',
    trySamplePrompts: 'Try these sample prompts:',
    undo: 'Undo',
    redo: 'Redo',
    aiThinking: 'AI is thinking...',
    proposedChanges: 'Proposed Changes',
    applyChanges: 'Apply Changes',
    dismiss: 'Dismiss',
    aiEngineReady: 'AI Engine ready',
    loadingAiModel: 'Loading AI model...',
    aiEngineOff: 'AI Engine off —',
    loadForAdvanced: 'load for advanced edits',
    instantCommands: 'translate, show/hide sections, add snippets, change font/colors/paper',
    aiEngineDesc: 'structural HTML edits, layout changes, custom modifications',
    aiLocalDesc: 'Model runs locally via WebGPU — no data leaves your browser. Larger models are more accurate but use more VRAM.',
    aiUpgradeDesc: 'upgrade to Starter or Professional to unlock advanced AI template editing.',
    upgrade: 'Upgrade',
    loadAiQuestion: 'Load AI Engine?',
    loadAiDesc: 'The on-device AI model will download and run locally using WebGPU. This requires ~1-3 GB of free VRAM/RAM and a modern GPU (M1+ Mac, or discrete GPU on Windows/Linux).',
  },
};



// WEBPACK FOOTER //
// app/intl/locales/fi.js